import React from 'react'
import { useDispatch } from 'react-redux'
import { showGlobalModal } from 'src/ducks/layout'
import Amplitude from 'src/utils/amplitudeHelper'
import scan from '../../images/icons/scanIcon.png'
import { GlobalModalTypes } from '../GlobalModals/GlobalModalContainer'

export const CPDMobile = ({ snapshot, loading, error }) => {
  const dispatch = useDispatch()

  if (!loading && !error && snapshot && snapshot.val() === "on") {

    const showCPDModal = () => {
      dispatch(showGlobalModal(GlobalModalTypes.CPD))
      Amplitude.showQR()
    }

    return (
      <div className="item-box">
        <div className="icon-wrapper">
          <img width="85%" src={scan} alt="icon" />
        </div>
        <p className="item-label">Claim CPD Points</p>
        <div onClick={showCPDModal} className="item-button">
          Scan
        </div>
      </div>
    )
  } else {
    return null
  }
}
